<div class="actie">
  <p>{{beschrijving}}</p>
  <wv-button (buttonClick)="onButtonClick()" [disabled]="disabled">{{knopTekst}}</wv-button>
</div>
